import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from '../../shared/services/profile.service';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { SignupService } from '../../core/services/sigup.service';
import { ToastrService } from 'ngx-toastr';
import { Themeservice } from '../../core/services/theme.service';
import { NgxImageCompressService } from 'ngx-image-compress';
import { ChessBoard, piecesTheme } from '../../shared/js/chess';
import { Subscription, interval, switchMap, timer } from 'rxjs';
import { LoginService } from '../../core/services/login.service';
import { DecryptionService } from '../../shared/services/decryption.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent implements OnInit {
  profilemember!: string | null;
  profileUserData!: any;
  statusinputShow!: boolean;
  statusValue = '';
  statussetdata: any;
  profileEditMode!: boolean;
  profileform!: FormGroup;
  newPasswordForm!: FormGroup;
  profilename: any;
  showPassword: boolean = false;
  shownewpassword: boolean = false;
  showoldPassword: boolean = false;
  showeditlebal = false;
  changeOTP = false;
  wrongOldPassword: any;
  forgotpassword!: FormGroup;
  userNameChangeData!: FormGroup;
  confirmOtp!: FormGroup;
  updateProfiledetail: any;
  confirmPasswordClass = 'form-control';
  notificationData: any;
  currentTheme: string | undefined;
  selectedImage: any;
  profileImg: string = '';
  boardColor: string = '';
  boardoddColor: string = '';
  selectedPiece: string = '';
  selectedtheme: string = '';
  customBox: boolean = false;
  chessboard: any;
  private boardPieceschange?: Subscription;
  isButtonDisabled: boolean = true;
  countdown: number = 60;
  timerSubscription: Subscription | undefined;
  newPasswordsection: boolean = false;
  forgetnewpassword: boolean = false;
  forgetconfirmpassword: boolean = false;
  otptoken: any;
  selectedTab: string = 'profile';
  loading: boolean = false;
  constructor(
    private profileData: ProfileService,
    private fb: FormBuilder,
    private router: Router,
    private userNameChange: SignupService,
    private toastr: ToastrService,
    private imageCompress: NgxImageCompressService,
    private themeService: Themeservice,
    private forgetpasswordapi: LoginService,private decryptionApi: DecryptionService
  ) {}

  ngOnInit() {
    this.profileform = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
    });
    this.userNameChangeData = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
    this.confirmOtp = this.fb.group({
      otp: ['', Validators.required],
    });
    this.forgotpassword = this.fb.group(
      {
        oldPassword: ['', [Validators.required]],
        newPassword: new FormControl(null, [Validators.required]),
        confirmPassword: new FormControl(null, [Validators.required]),
      },
      {
        validator: this.ConfirmedValidator('newPassword', 'confirmPassword'),
      }
    );

    this.newPasswordForm = this.fb.group(
      {
        forgetPassword: new FormControl(null, Validators.required),
        forgetconfirmPassword: new FormControl(null, Validators.required),
      },
      {
        validator: this.ConfirmedValidator(
          'forgetPassword',
          'forgetconfirmPassword'
        ),
      }
    );
    const savedValues = JSON.parse(localStorage.getItem('boardPieces') || '');
    this.selectedPiece = savedValues.pieces;
    this.boardColor = savedValues.white;
    this.boardoddColor = savedValues.black;
    this.selectedtheme = savedValues.theme;
    this.profiledetails();
    // this.notificationDetails();
  }

  setCSSVariables() {
    let boardPiece: any = localStorage.getItem('boardPieces');
    let boardData = JSON.parse(boardPiece);

    if (boardData.theme === 'Custom') {
      this.customBox = true;
    }

    this.selectedPiece = boardData.pieces;
    this.boardColor = boardData.white;
    this.boardoddColor = boardData.black;

    document.documentElement.style.setProperty(
      '--local-storage-oddcolor',
      this.boardColor
    );
    document.documentElement.style.setProperty(
      '--local-storage-color',
      this.boardoddColor
    );
  }

  profiledetails() {
    let userDATA = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    this.profileData.settingprofileData(userDATA.username).subscribe((res) => {
      const decrypt=  this.decryptionApi.decrypt(res.payload);
      const jsondecrpt=JSON.parse(decrypt);
      this.profileform.patchValue(jsondecrpt);
      this.profileUserData = jsondecrpt;
      this.profilename = jsondecrpt;
      this.profileImg = this.profileUserData.image;
      this.statusValue = this.profileUserData.status;
    });
  }


  statusinput() {
    this.statusinputShow = true;
  }

  statusData(data: any) {
    const inputValue = {
      status: data,
    };
    this.statusinputShow = false;
    this.profileData.profileupdateData(inputValue).subscribe((res) => {
      res.success && (this.statussetdata = data);
    });
  }

  profileEditshow() {
    this.profileEditMode = true;
  }
  profileEditCancel() {
    this.profileEditMode = false;
  }

  updateProfileData() {
    this.profilename = this.profileform.value;
    this.profileData
      .profileupdateData(this.profileform.value)
      .subscribe((res) => {
        this.updateProfiledetail = this.profileform.value;
        this.profileEditMode = false;
      });
  }

  passwordShow() {
    this.forgotpassword.reset();
  }

  boardPiecemenushow() {
    this.setCSSVariables();
    if ((this.selectedTab = 'board')) {
      setTimeout(() => {
        ChessBoard('hijk', 'start');
      });
    }
  }

  forgetPassword(data: any) {
    const forgotpasswords = {
      oldPassword: data.oldPassword,
      newPassword: data.confirmPassword,
    };
    this.profileData.changespassword(forgotpasswords).subscribe({
      next: (res) => {
        this.wrongOldPassword = res.success;
        this.toastr.success(res.messages);
        this.forgotpassword.reset();
      },
      error: (error) => {
        this.toastr.error(error.error.message);
        this.wrongOldPassword = error.error.message;
      },
    });
  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  profilememberDetails(username: string) {
    this.router.navigate(['/profile', username]);
  }

  friendList() {
    this.router.navigate(['/friends']);
  }

  newUsername(data: any) {
    if (data.username !== '' && data.password !== '') {
      this.userNameChange.postUserName(data).subscribe({
        next: (response) => {
          if (response.success) {
            let userDATA = JSON.parse(
              localStorage.getItem('loggedInUser') || '{}'
            );
            userDATA.username = data.username;
            let newUserDataStr = JSON.stringify(userDATA);
            localStorage.setItem('loggedInUser', newUserDataStr);

            window.location.reload();
          }
        },
        error: (err) => {
          this.toastr.error(err.error.message);
        },
      });
    }
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.selectedImage = e.target.result;
        this.compressImage();
      };
      reader.readAsDataURL(file);
    }
  }

  async compressImage() {
    const image = new Image();
    image.src = this.selectedImage;

    image.onload = async () => {
      const maxWidth: any = 50;
      const height = 50;
      const quality = 0.9; // You can adjust the quality as needed

      const result = await this.imageCompress.compressFile(
        image.src,
        maxWidth,
        height,
        quality
      );
      this.selectedImage = result;
      this.selectedImage && this.uploadImage();
    };
  }

  uploadImage() {
    this.profileData
      .profileUploadData({ image: this.selectedImage })
      .subscribe({
        next: (res) => {
          this.profileImg = this.selectedImage;
        },
        error: (err) => {},
      });
  }

  switchTheme(data: any): void {
    const selectedTheme = data;
    this.themeService.setTheme(selectedTheme);
    this.currentTheme = selectedTheme;
    this.themeService.updateTheme({ theme: this.currentTheme }).subscribe({});
  }

  colorchange() {
    this.selectedtheme = 'Custom';
    this.boardPieceChange();
  }

  boardPieceChange() {
    let BoardPiece = {
      pieces: this.selectedPiece,
      theme: this.selectedtheme,
      white: this.boardColor,
      black: this.boardoddColor,
    };
    if (this.boardColor === this.boardoddColor) {
      this.toastr.error('Same Colors.');
      return;
    }
    localStorage.setItem('boardPieces', JSON.stringify(BoardPiece));

    this.setCSSVariables();
    if (this.boardPieceschange) {
      this.boardPieceschange.unsubscribe();
    }

    this.boardPieceschange = timer(3000)
      .pipe(
        switchMap(() =>
          this.profileData.boardPiecedata({ boardAndPieces: BoardPiece })
        )
      )
      .subscribe({
        next: (res: any) => {},
        error: (error) => {},
      });
  }

  piecedatas(data: any) {
    this.boardPieceChange();
    piecesTheme(data);
    this.selectedPiece = data;
    ChessBoard('hijk', 'start');
  }

  borderData(data: any) {
    const themeColors: any = {
      BI: { boardColor: '#ffffff', boardoddColor: '#6e8faf' },
      Classic: { boardColor: '#f0d9b5', boardoddColor: '#b58863' },
      Barbie: { boardColor: '#f9dddd', boardoddColor: '#ec8dc0' },
      'Urban Slate': { boardColor: '#767474', boardoddColor: '#413e3e' },
      dr: { boardColor: '#fff8ad', boardoddColor: '#c46464' },
      Froggy: { boardColor: '#fff8ad', boardoddColor: '#64c46f' },
      green: { boardColor: '#EBECD0', boardoddColor: '#739552' },
      'Mint Breeze': { boardColor: '#b6f0b2', boardoddColor: '#7498be' },
      'Cranberry Mist': { boardColor: '#b8b8b8', boardoddColor: '#8d4444' },
      cs: { boardColor: '#f7b0b0', boardoddColor: '#62a1df' },
      ts: { boardColor: '#E9ECF0', boardoddColor: '#B5BDCE' },
      eo: { boardColor: '#3dffd8', boardoddColor: '#5d58ad' },
      Av: { boardColor: '#88fbf9', boardoddColor: '#a18c78' },
    };

    if (themeColors[data]) {
      this.selectedtheme = data;
      this.boardColor = themeColors[data].boardColor;
      this.boardoddColor = themeColors[data].boardoddColor;
      this.customBox = false;
    } else if (data === 'Custom') {
      this.customBox = true;
    }

    document.documentElement.style.setProperty(
      '--local-storage-oddcolor',
      this.boardColor
    );
    document.documentElement.style.setProperty(
      '--local-storage-color',
      this.boardoddColor
    );
    this.boardPieceChange();
  }

  OtpsendData() {
    this.loading = true;
    let userDATA = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    let data = {
      query: userDATA.username,
    };

    this.forgetpasswordapi.forgetpassword(data).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.toastr.success(res.messages);
        this.changeOTP = true;
        this.startCountdown();
      },
    });
  }

  OtpPopups() {
    let userDATA = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    const otp = this.confirmOtp.value;
    let otpData = {
      query: userDATA.username,
      otp: otp.otp,
    };

    this.forgetpasswordapi.verifyOtpCode(otpData).subscribe({
      next: (response) => {
        const decrypt=  this.decryptionApi.decrypt(response.payload);
      const jsondecrpt=JSON.parse(decrypt);
        this.otptoken = jsondecrpt.token;
        if (response.success) {
          this.changeOTP = false;
          this.newPasswordsection = true;
        }
      },
    });
  }

  onResend(): void {
    let userDATA = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    let data = {
      query: userDATA.username,
    };
    this.resetCountdown();
    this.forgetpasswordapi.forgetpassword(data).subscribe({
      next: (response: any) => {
        this.toastr.success(response.messages);
        this.startCountdown();
      },
    });
  }

  startCountdown(): void {
    this.stopCountdown(); // Ensure any existing timer is stopped before starting a new one
    this.isButtonDisabled = true;
    this.countdown = 60; // Reset countdown
    this.timerSubscription = interval(1000).subscribe(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.isButtonDisabled = false;
        this.stopCountdown();
      }
    });
  }

  stopCountdown(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = undefined;
    }
  }
  
  resetCountdown(): void {
    this.countdown = 60;
    this.isButtonDisabled = true;
    this.startCountdown();
  }

  newpasswordData(data: any) {
    const confirmPasswordData = {
      password: data.forgetconfirmPassword,
    };
    this.forgetpasswordapi
      .Forgetpassword(this.otptoken, confirmPasswordData)
      .subscribe({
        next: (response: any) => {
          this.toastr.success(response.messages);
          this.changeOTP = true;
          this.newPasswordsection = false;
        },
        error: (error) => {
          this.toastr.error(error.error.messages);
        },
      });
  }
}
